"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HellofreshService = void 0;
class HellofreshService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a very specific spend report per code for Hello Fresh (paginated).
     * @param page 'Page number (default 1)
     * @param count Number of results per page (default 10)
     * @param q Query to filter the results on
     * @returns HelloFreshSpendReportResponse
     * @throws ApiError
     */
    getExternalSpendReport(page, count, q) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/ext/hellofresh/spend-report',
            query: {
                'page': page,
                'count': count,
                'q': q,
            },
        });
    }
}
exports.HellofreshService = HellofreshService;
